import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function useContactNames() {
  const api = useAxios();

  const { data } = useQuery({
    queryKey: ["contact-names"],
    queryFn: () => api.get("/contacts/names"),
    staleTime: 5 * 60 * 1000,
    throwOnError: false,
  });

  return { names: data?.data ?? [] };
}
